<template>
  <div style="position: relative; overflow: hidden;">
    <ul class="tr calendar-header">
      <li class="td" v-for="th in days" :key="th">{{th}}</li>
    </ul>
    <swiper
      ref="mySwiper"
      class="swipe"
      :options="mySwiperOption"
    >
      <swiper-slide v-for="(month, index) in list" :key="index">
        <div class="calendar-section" :class="{'week': mode == 'week'}">

          <ul class="tr calendar-body">
            <li class="td" :class="{'is-today': isToday(day), 'is-selected': isSelected(day)}" v-for="(day) in month" :key="JSON.stringify(day.obj)" @click.stop="changeDate(day)">
              <span>{{day.solar}}</span>
              <span>{{day.lunar}}</span>
            </li>
          </ul>
        </div>
      </swiper-slide>
    </swiper>
    <div class="footer" @click="toggleMode">
      <div v-if="mode === 'week'" class="expand-btn"></div>
      <van-icon v-else name="arrow-up" />
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import calendar from 'solarday2lunarday'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper.css'
export default {
  props: {
    // currentDate: {type: moment, default: () => moment()},
    // endDate: { type: moment, default: () => moment().add(365, 'days') },
    weekStart: { type: Number, default: 0 }
  },
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      days: ['日', '一', '二', '三', '四', '五', '六'],
      date: moment(),
      months: [],
      mode: 'week',
      curIndex: 1,
      swipeStyle: '',
      listObj: {
        'week': [],
        'month': []
      },
      mySwiperOption: {
        // notNextTick: true,
        loop: false,
        autoplay: false,
        initialSlide: 12,
        // autoHeight: true,
        observer: true,
        observeParents: true,
        // 监听滑动事件
        onSlideChangeEnd: swiper => {
          this.curIndex = swiper.realIndex
          if (this.mode === 'month') {
            if (moment(this.list[swiper.realIndex][10].obj).clone().month() !== moment().clone().month()) {
              this.date = moment(this.list[swiper.realIndex][10].obj).clone().startOf('month')
            } else {
              this.date = moment()
            }
          } else if (this.mode === 'week') {
            if (moment(this.list[swiper.realIndex][0].obj).clone().week() !== moment().clone().week()) {
              this.date = moment(this.list[swiper.realIndex][this.dayInWeek].obj).clone()
            } else {
              this.date = moment()
            }
          }
          this.setHeight()
        }
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    dayInWeek () {
      return moment(this.date).clone().day()
    },
    list () {
      return this.listObj[this.mode]
    }
  },
  watch: {
    date (newVal, oldVal) {
      // 选定日期变化，月份没变更不需重新渲染日历，月份变更之后需要重新渲染日历内容
      // if (moment(newVal).month() === moment(oldVal).month()) {
      //   return
      // } else {
      //   this.generatePagiesMonth()
      // }
      this.$emit('change', moment(newVal).clone())
    }
  },
  created () {
    this.init()
    this.$nextTick(() => {
      this.curIndex = this.mySwiperOption.initialSlide = 12
    })
  },
  mounted () {
    this.setHeight()
  },
  methods: {
    init () {
      this.listObj = {
        'week': this.generatePagiesWeek(),
        'month': this.generatePagiesMonth()
      }
    },
    setHeight () {
      let doms = document.getElementsByClassName('calendar-section')
      // let bottom = document.getElementsByClassName('swiper-container')[0].offsetHeight - doms[this.curIndex].offsetHeight - 28
      document.getElementsByClassName('swiper-slide')[this.curIndex].style.height = doms[this.curIndex].offsetHeight + 'px'
      document.getElementsByClassName('swiper-container')[0].style.height = doms[this.curIndex].offsetHeight + 'px'
      // console.log(document.getElementsByClassName('swiper-container')[0].offsetHeight, doms[this.curIndex].offsetHeight)
      // document.getElementsByClassName('swiper-container')[0].offsetHeight
      // bottom = bottom <= 0 ? 0 : bottom
      // this.swipeStyle = `bottom: ${bottom}px;`
    },
    toggleMode () {
      if (this.mode === 'month') {
        this.mode = 'week'
      } else {
        this.mode = 'month'
      }
      setTimeout(() => {
        this.setHeight()

        const date = moment(this.date).clone()
        let i = this.list.findIndex((m, index) => {
          let r = false
          let sub = moment(date).startOf(this.mode)
          if (this.mode === 'week') {
            r = moment(m[0].obj).clone().isSame(moment(sub), 'day')
            // r && console.log(moment(m[0].obj), sub, m, index)
          } else if (this.mode === 'month') {
            r = moment(sub).month() === moment(m[10].obj).clone().month() && moment(sub).year() === moment(m[10].obj).clone().year()
            // r && console.log(moment(sub).month(), moment(m[10].obj).clone().month(), sub, index)
          }
          return r
        })
        console.log(i)
        this.swiper.slideTo(i, 0)
      })
    },
    isToday ({obj}) {
      return moment(obj).isSame(moment(), 'day')
    },
    isSelected ({obj}) {
      return moment(obj).isSame(moment(this.date).clone(), 'day') && !this.isToday({obj})
    },
    generatePagiesWeek () {
      // 轮播日历,以周为单位
      const weeks = []
      const date = moment(this.date).clone()
      const curWeek = this.generateDaysInWeek(date)
      weeks.push(this.handleDateObj(curWeek))
      for (let i = 0; i < 12; i++) {
        const preDate = moment(date).clone().subtract(i + 1, 'week')
        const preWeek = this.generateDaysInWeek(preDate)
        weeks.unshift(this.handleDateObj(preWeek))
      }
      for (let i = 0; i < 24; i++) {
        const nextDate = moment(date).clone().add(i + 1, 'week')
        const nextWeek = this.generateDaysInWeek(nextDate)
        weeks.push(this.handleDateObj(nextWeek))
      }
      return weeks
    },
    generatePagiesMonth () {
      // 轮播日历,以月为单位
      const months = []
      const date = moment(this.date).clone()
      const curMonth = this.generateDaysInMonth(date)
      months.push(this.handleDateObj(curMonth))
      for (let i = 0; i < 12; i++) {
        const preDate = moment(date).clone().subtract(i + 1, 'month')
        const preMonth = this.generateDaysInMonth(preDate)
        months.unshift(this.handleDateObj(preMonth))
      }
      for (let i = 0; i < 24; i++) {
        const nextDate = moment(date).clone().add(i + 1, 'month')
        const nextMonth = this.generateDaysInMonth(nextDate)
        months.push(this.handleDateObj(nextMonth))
      }
      return months
    },
    handleDateObj (arr) {
      return arr.map(m => {
        let lunarObj = calendar.solar2lunar(moment(m).clone().format('YYYY-MM-DD'))
        return {
          obj: m,
          solar: moment(m).clone().date(),
          lunar: lunarObj.festivalName ? lunarObj.festivalName : lunarObj.IDayCn
        }
      })
    },
    // 根据日期生成整周
    generateDaysInWeek (date) {
      let res = []
      // const dayIndex = moment(date).day() // 0星期日
      let first = moment(date).clone().startOf('week')
      res.push(moment(first))
      for (let i = 0; i < 6; i++) {
        res.push(moment(first.add(1, 'day')))
      }
      return res
    },
    // 根据日期生成整月
    generateDaysInMonth (date) {
      let res = []
      // this.currentMonth = moment(date).get('month') // 第几个月
      const dayIndex = moment(date).date() // 这个月的第几天
      const daysInMonth = moment(date).daysInMonth() // 月份总共天数

      // 插入整月的日期
      let first = moment(date).clone().startOf('month')
      res.push(moment(first))
      for (let i = 0; i < daysInMonth - 1; i++) {
        // res.push(first.add(1, 'day').format('MM-DD'))
        res.push(moment(first.add(1, 'day')))
      }

      // 补齐1号之前的
      let res1 = this.handleFrontList(date)
      // 补齐月末后面的
      let res2 = this.handleBehindList(date)
      return res1.concat(res).concat(res2)
    },
    handleFrontList (date) {
      let res = []
      let start = moment(date).clone().startOf('month')
      let sub = start.day() // 星期几 0星期日 6星期六
      for (let i = 0; i < sub; i++) {
        res.unshift(moment(start.subtract(1, 'day')))
      }
      return [...res]
    },
    handleBehindList (date) {
      let res = []
      let start = moment(date).clone().startOf('month')
      let daysInMonth = moment(date).daysInMonth()
      let end = start.add(daysInMonth - 1, 'day')
      let sub = end.day() // 星期几 0星期日 6星期六

      for (let i = 0; i < 6 - sub; i++) {
        res.push(moment(end.add(1, 'day')))
      }
      return [...res]
    },
    // 点击日期
    changeDate ({obj}) {
      if (this.mode === 'month') {
        if (moment(obj).clone().month() > moment(this.date).clone().month()) {
          this.swiper.slideNext()
        } else if (moment(obj).clone().month() < moment(this.date).clone().month()) {
          this.swiper.slidePrev()
        }
      }
      this.date = moment(obj).clone()
    }
  }
}
</script>
<style lang="less" scoped>
.tr {
  display: flex;
}
.td {
  flex: 1;
}
.swiper-slide {
  transition: height 300ms;
}
.swipe {
  position: relative;
  // /deep/ .van-swipe-item {
  //   height: auto;
  // }
  .swiper-slide {
    // overflow: hidden;
    text-align: center;
    box-shadow: 0 15px 5px -15px #e8e8e8;
  }
}

.calendar-header {
  line-height: 38px;
  font-size: 12px;
}
.calendar-section {
  padding-bottom: 20px;
  cursor: pointer;
  font-size: 12px;

  .calendar-body {
    flex-wrap: wrap;
    .td {
      flex: auto;
      width: 53.5px;
      height: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 10px;
      span:first-child {
        font-weight: 600;
        font-size: 14px;
      }
    }
    .td.is-today {
      span:first-child {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        color: #426bef;
        font-size: 14px;
        // background-color: #426bef;
      }
      span:nth-child(2) {
        color: #426bef;
      }
    }
    .td.is-selected {
      span:first-child {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        font-size: 14px;
        background-color: #ccc;
      }
      span:nth-child(2) {
        // color: #bbb;
      }
    }
  }

  &.week {
    // height: 80px;
    // overflow: hidden;
  }
}
.footer {
  position: absolute;
  bottom: 3px;
  height: 18px;
  width: 100%;
  font-size: 10px;
  z-index: 99;

  .expand-btn {
    width: 20px;
    height: 3px;
    background: #cbcbcb;
    border-radius: 1px;
    margin: 12px auto 0;
  }
  span {
    display: inline-block;
    margin: 0 auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/schedule-list/my-calender.vue